const colors = {
    offWhite : '#E8E8E8',
    charcoal : '#101010',
    azure : '#1f67ab',
    paleBlue : '#70C0EE',
    lightGray : '#BBB',
    gray : '#222'
}

export default colors;